// story-swiper
import { onDestroy, onMount } from "@/modules/_";
import { reduced } from "@lib/gsap";
import Swiper from "swiper";
import { FreeMode, Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";

const SPACE_BETWEEN = 24;
const MOMENTUM_RATIO = 0.6;
const MOMENTUM_BOUNCE = false;

export default function (element: HTMLElement) {
  const swiperEl = element.querySelector<HTMLElement>(
    '[story-swiper="cms-list-w"]',
  );
  const wrapper = element.querySelector<HTMLElement>(
    '[story-swiper="cms-list"]',
  );
  const slides = Array.from(
    element.querySelectorAll<HTMLElement>('[story-swiper="cms-item"]'),
  );
  if (!swiperEl || !wrapper || slides.length === 0) return;

  let instance: Swiper | null = null;

  onMount(() => {
    // Swiper class names layered on top of existing Webflow ones — DOM not restructured.
    swiperEl.classList.add("swiper");
    wrapper.classList.add("swiper-wrapper");
    slides.forEach((slide) => slide.classList.add("swiper-slide"));

    instance = new Swiper(swiperEl, {
      modules: [FreeMode, Mousewheel],
      slidesPerView: "auto",
      spaceBetween: SPACE_BETWEEN,
      grabCursor: true,
      resistanceRatio: 0.5,
      freeMode: reduced
        ? false
        : {
            enabled: true,
            sticky: true,
            momentum: true,
            momentumRatio: MOMENTUM_RATIO,
            momentumBounce: MOMENTUM_BOUNCE,
          },
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
    });
  });

  onDestroy(() => {
    instance?.destroy(true, true);
    instance = null;
    swiperEl.classList.remove("swiper");
    wrapper.classList.remove("swiper-wrapper");
    slides.forEach((slide) => slide.classList.remove("swiper-slide"));
  });
}
